import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Chips extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return <div className={styles.chips} data-json={JSON.stringify(content)} />;
    }
}

const ChipsBox = props => {
    const { headPoster } = props.content;

    return (
        <div className={styles.chipsBox}>
            <Chip id="170137" type="struct" title="美食盛典-头图" groupName="正文-首页" content={headPoster}>
                <Chips />
            </Chip>
            <Chip id="230127" type="struct" title="美食盛典-首页导航" groupName="正文-首页" content={headPoster}>
                <Chips />
            </Chip>
            <Chip id="170138" type="struct" title="美食盛典-已上线板块" groupName="正文-首页" content={headPoster}>
                <Chips />
            </Chip>
        </div>
    );
};

ChipsBox.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(ChipsBox);
